import TalksPage from './TalksPage';
export default TalksPage;
